
import {Component, Vue} from 'vue-property-decorator';
import DynamicTable from '@/components/datatables/DynamicTable.vue';
import {readAdminExternalDataList} from '@/store/admin/getters';
import {dispatchDeleteExternalData, dispatchGetExternalDataListAdmin} from '@/store/admin/actions';

@Component({
  components: {DynamicTable},
})
export default class ListExternalData extends Vue {
  private headers = [
    {
      text: this.$t('action'),
      value: 'action',
      align: 'center',
      filterable: false,
      sortable: false,
      router_name: 'main-admin-external-data-edit',
      width: '100px',
      delete_function: this.deleteFunction,
    },
    {text: this.$t('name'), value: 'name', sortable: true, align: 'left'},
    {text: this.$t('description'), value: 'description', sortable: true, align: 'left'},
    {text: 'Total de linhas', value: 'total_rows', sortable: true, align: 'left'},
    {text: this.$t('created_by'), value: 'created_by_user', sortable: true, align: 'left', type: 'user_object'},
    {text: this.$t('updated_by'), value: 'updated_by_user', sortable: true, align: 'left', type: 'user_object'},
  ];

  public async mounted() {
    await dispatchGetExternalDataListAdmin(this.$store);
  }

  private async deleteFunction(id) {
    await dispatchDeleteExternalData(this.$store, id);
    await dispatchGetExternalDataListAdmin(this.$store);
  }


  public get externalDataList() {
    return readAdminExternalDataList(this.$store);
  }

}
